/* eslint-disable */

import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
});

// Automatically run the `init` action for every module,
// if one exists.
Object.keys(modules).forEach((moduleName) => {
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`);
  }
});

// Events
const debouncedUpdate = _.debounce(() => {
  store.commit('application/SET_APP_WIDTH', window.innerWidth);
}, 200);

const updLang = (data) => {
  store.commit('application/SET_CURRENT_LANGUAGE', data.detail.split('_')[0]);
};

window.addEventListener('resize', debouncedUpdate);
window.addEventListener('getLang', updLang);

export default store;
